import React from "react";
import {
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Tooltip,
  IconButton,
  FormHelperText,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";

export const merchant_fields = [
  {
    label: "Fix Amount Per TX",
    name: "amount_tx_processing",
    type: "text",
    shrink: true,
    maxLength: 32,
    required: (formData) => formData.acquirer.iso === "True",
    helperText: "Fixed MDR (Merchant Discount Rate) per transaction",
  },
  {
    label: "% Merchant Discount Rate (MDR)",
    name: "percent_tx_processing",
    type: "text",
    shrink: true,
    maxLength: 32,
    required: (formData) => formData.acquirer.iso === "True",
    helperText: "Percentage-based MDR per transaction",
  },
];

const MerchantFields = ({
  formData,
  handleInputChange,
  submittedSteps,
  invalidFields,
}) => {
  return (
    <>
      {merchant_fields.map((field) => {
        const isRequired =
          typeof field.required === "function"
            ? field.required(formData)
            : field.required;

        const fieldId = `merchant.${field.name}`;
        const isError =
          invalidFields?.includes(fieldId) ||
          (submittedSteps.has("merchant") &&
            isRequired &&
            !formData.merchant[field.name]);

        // Validación para amount_tx_processing y percent_tx_processing
        let numericError = false;
        let numericHelper = "";
        if (
          (field.name === "amount_tx_processing" ||
            field.name === "percent_tx_processing") &&
          isRequired &&
          (isError || (submittedSteps && submittedSteps.has("merchant")))
        ) {
          const value = formData.merchant[field.name] || "";
          const numberRegex = /^(0|[1-9]\d*)(\.\d{1,3})?$/;
          if (value.trim() === "") {
            numericError = true;
            numericHelper = "This field is required";
          } else if (!numberRegex.test(value)) {
            numericError = true;
            numericHelper =
              "Must be a number with up to 3 decimals and minimum 0";
          }
        }

        return (
          <Grid item xs={12} sm={6} key={field.name}>
            {field.type === "select" ? (
              <FormControl fullWidth required={isRequired} error={isError}>
                <InputLabel
                  id={`${field.name}-label`}
                  sx={{
                    "& .MuiFormLabel-asterisk": {
                      color: "red",
                      fontSize: "1.2rem",
                    },
                  }}
                >
                  {field.label}
                  {field.helperText && (
                    <Tooltip title={field.helperText} arrow>
                      <IconButton
                        size="small"
                        sx={{ padding: 0, marginLeft: "8px" }}
                      >
                        <InfoIcon color="primary" fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  )}
                </InputLabel>
                <Select
                  labelId={`${field.name}-label`}
                  name={field.name}
                  label={field.label}
                  value={formData.merchant[field.name] || ""}
                  onChange={handleInputChange}
                >
                  {field.options.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </Select>
                {isError && (
                  <FormHelperText error>This field is required</FormHelperText>
                )}
              </FormControl>
            ) : field.type === "date" ? (
              <TextField
                label={
                  <>
                    {field.label}
                    {field.helperText && (
                      <Tooltip title={field.helperText} arrow>
                        <IconButton
                          size="small"
                          sx={{ padding: 0, marginLeft: "4px" }}
                        >
                          <InfoIcon color="primary" fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    )}
                  </>
                }
                name={field.name}
                type="date"
                value={formData.merchant[field.name] || ""}
                onChange={handleInputChange}
                InputLabelProps={{
                  shrink: true,
                  sx: {
                    "& .MuiFormLabel-asterisk": {
                      color: "red",
                      fontSize: "1.2rem",
                    },
                  },
                }}
                required={isRequired}
                error={isError}
                helperText={isError ? "This field is required" : ""}
                fullWidth
                InputProps={{
                  sx: {
                    "&.Mui-error": {
                      borderColor: "red",
                    },
                  },
                }}
              />
            ) : (
              <TextField
                label={
                  <>
                    {field.label}
                    {field.helperText && (
                      <Tooltip title={field.helperText} arrow>
                        <IconButton
                          size="small"
                          sx={{ padding: 0, marginLeft: "4px" }}
                        >
                          <InfoIcon color="primary" fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    )}
                  </>
                }
                name={field.name}
                value={formData.merchant[field.name] || ""}
                onChange={handleInputChange}
                InputLabelProps={{
                  shrink: field.shrink,
                  sx: {
                    "& .MuiFormLabel-asterisk": {
                      color: "red",
                      fontSize: "1.2rem",
                    },
                  },
                }}
                inputProps={{ maxLength: field.maxLength }}
                required={isRequired}
                error={numericError || isError}
                helperText={
                  numericError
                    ? numericHelper
                    : isError
                    ? "This field is required"
                    : ""
                }
                fullWidth
              />
            )}
          </Grid>
        );
      })}
    </>
  );
};

export default MerchantFields;
